import { Component } from '@angular/core';

@Component({
    selector: 'app-digital-e-library',
    templateUrl: './digital-e-library.component.html',
    styleUrls: ['./digital-e-library.component.scss']
})
export class DigitalELibraryComponent {
    keyFeatures = [
        {
            icon: 'auto_stories',
            title: 'Interactive Storybooks & e-Books',
            description: 'Engaging digital books for early learners'
        },
        {
            icon: 'ondemand_video',
            title: 'Audio & Video Content',
            description: 'Multi-sensory learning experiences'
        },
        {
            icon: 'style',
            title: 'Thematic Reading Collections',
            description: 'Curated collections for different class levels'
        },
        {
            icon: 'extension',
            title: 'Engaging Activities',
            description: 'Promote comprehension and creativity'
        },
        {
            icon: 'child_care',
            title: 'Safe, Child-Friendly Interface',
            description: 'Secure environment designed for kids'
        }
    ];

    statistics = [
        { value: '5,000+', label: 'eBooks' },
        { value: '25+', label: 'Genres' },
        { value: '2', label: 'Languages' }
    ];
}
